import React from 'react';
import styled from 'styled-components';
import { Domain } from '../../../types/globalTypes';
import { COLORS, device, ROUTES } from '../../../constants';
import { Title, Text } from '../../../components';
import { SHADOW } from '../../../constants/animations';
import { Link } from 'react-router-dom';
import { MotionIndustryCard } from '../../../components/Motion';

interface IndustryItemProps {
  industry: Domain;
  icon: React.FC;
  projectName: string;
}

const IndustryItem = ({
  industry,
  icon: Icon,
  projectName,
}: IndustryItemProps) => {
  return (
    <IndustryItemWrapper>
      <Link to={`${ROUTES.PROJECT}/${projectName.replace(/\s+/g, '_')}`}>
        <IndustryItemImageWrapper>
          <img src={industry.Image} draggable={false} alt={industry.Name} />
        </IndustryItemImageWrapper>
      </Link>
      <IndustryItemContentWrapper>
        <IndustryItemContent>
          <IndustryItemIconWrapper>
            <Icon />
          </IndustryItemIconWrapper>
          <IndustryItemDescription>
            <Title title={industry.Name} weight={600} />
            <IndustryItemDescriptionText text={industry.Caption} />
          </IndustryItemDescription>
        </IndustryItemContent>
      </IndustryItemContentWrapper>
    </IndustryItemWrapper>
  );
};
const IndustryItemWrapper = styled(MotionIndustryCard)`
  display: flex;
  flex-direction: column;
  &:hover {
    box-shadow: ${SHADOW.HOVER.SERVICE_CARD};
    svg {
      color: ${COLORS.MAIN_RED};
    }
  }
  @media screen and (${device.sm}) {
    flex-direction: row;
  }
`;
const IndustryItemImageWrapper = styled.div`
  height: 477px;
  width: auto;
  padding: 40px;
  border: 1px solid ${COLORS.INDUSTRY_BORDER};
  border-bottom: 0;
  display: flex;
  justify-content: center;
  img {
    max-width: 100%;
    height: 100%;
    object-fit: scale-down;
  }
  @media screen and (${device.lg}) {
    height: 400px;
  }
  @media screen and (${device.md}) {
    height: 200px;
    padding: 20px;
  }
  @media screen and (${device.bsm}) {
    height: 150px;
    padding: 15px;
  }
  @media screen and (${device.sm}) {
    height: 100px;
    padding: 0;
    flex: 0 0 30%;
    border: none;
    img {
      object-fit: contain;
      width: 100%;
    }
  }
`;
const IndustryItemContentWrapper = styled.div`
  padding: 40px;
  background-color: ${COLORS.WHITE};
  min-height: 240px;
  box-sizing: border-box;
  flex: 1;
  @media screen and (${device.lg}) {
    padding: 25px;
  }
  @media screen and (${device.md}) {
    padding: 15px;
    min-height: 170px;
  }
  @media screen and (${device.sm} ){
    padding: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 0;
  }
`;
const IndustryItemContent = styled.div`
  display: flex;
  gap: 20px;
  @media screen and (${device.lg}) {
    gap: 10px;
  }
  @media screen and (${device.md}) {
    gap: 10px;
    flex-direction: column;
  }
  @media screen and (${device.sm}) {
    gap: 2px;
  }
`;
const IndustryItemIconWrapper = styled.div`
  width: 40px;
  height: 40px;
  flex: 1 0 auto;
  svg {
    width: 100%;
    height: 100%;
  }
  @media screen and (${device.md}) {
    width: 25px;
    height: 25px;
  }
  @media screen and (${device.sm}) {
    width: 15px;
    height: 15px;
  }
`;
const IndustryItemDescription = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  overflow: hidden;
  span {
    font-size: 24px;
    line-height: 30px;
  }
  @media screen and (${device.lg}) {
    font-size: 21px;
    line-height: 26px;
  }
  @media screen and (${device.md}) {
    gap: 10px;
    span {
      font-size: 16px;
      line-height: 20px;
    }
  }
  @media screen and (${device.sm}) {
    gap: 5px;
    span {
      font-size: 10px;
      line-height: 12px;
    }
  }
`;
const IndustryItemDescriptionText = styled(Text)`
  font-size: 18px;
  line-height: 27px;
  @media screen and (${device.md} ){
    font-size: 14px;
    line-height: 20px;
  }
  @media screen and (${device.sm}) {
    font-size: 8px;
    line-height: 10px;
  }
`;
export { IndustryItem };
